class CdpTrackingCode {
  // Normalised Shopify option name => cdp.asia item properties it fills. Options not listed here
  // are sent under their normalised name, e.g. "Pattern" => pattern.
  static OPTION_PROPERTY_MAP = {
    size: ['size', 'uk_size'],
    uk_size: ['size', 'uk_size'],
    shoe_size: ['size', 'uk_size'],
    color: ['color'],
    colour: ['color'],
    width: ['width'],
    style: ['style'],
    fitting: ['fitting'],
  };

  constructor() {
    this.cdpTrackingData = JSON.parse(document.querySelector('#cdp-tracking-data').textContent);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', this.runOnDOMContentLoaded.bind(this), {once: true});
    } else {
      this.runOnDOMContentLoaded();
    }
  }

  runOnDOMContentLoaded() {
    const cartDrawerLinks = document.querySelectorAll('[aria-controls="mini-cart"]');

    for (const link of cartDrawerLinks) {
      link.addEventListener('click', this.trackViewCart.bind(this));
    }

    if (Object.hasOwn(this.cdpTrackingData, 'customer_id')) {
      setInterval(this.trackIdentifyUser.bind(this), 1000 * 60 * 5);
    }

    switch (this.cdpTrackingData.page_type) {
      case 'product': {
        this.trackViewProduct();
        document.addEventListener('variant:changed', this.trackViewProduct.bind(this));
        break;
      }
      case 'cart': {
        this.trackViewCart();
        break;
      }
      case 'search': {
        this.trackProductSearch();
        break;
      }
      case 'article': {
        this.trackViewBlogs();
        break;
      }
    }

    const checkoutButtons = document.querySelectorAll('.checkout-button');

    for (const button of checkoutButtons) {
      button.addEventListener('click', this.trackCheckout.bind(this));
      button.form.addEventListener('submit', this.trackCheckout.bind(this));
    }

    document.documentElement.addEventListener('cart-drawer:rerendered', this.onCartDrawerRerendered.bind(this));

    const logged_in_last_time = localStorage.getItem('logged_in_last_time');
    const is_logged_in = Object.hasOwn(this.cdpTrackingData, 'customer_id');

    if (is_logged_in) {
      localStorage.setItem('logged_in_last_time', '1');
    } else {
      localStorage.removeItem('logged_in_last_time');
    }

    if (is_logged_in && !logged_in_last_time) {
      this.trackUserSignIn();
    }
  }

  onCartDrawerRerendered(event) {
    const checkoutButtons = event.detail.cartDrawer.querySelectorAll('.checkout-button');

    for (const button of checkoutButtons) {
      button.addEventListener('click', this.trackCheckout.bind(this));
    }
  }

  trackViewProduct(event) {
    const data = {};

    if (event && event.detail && event.detail.variant) {
      const variant = event.detail.variant;

      variant.product_id = variant.sku + '_' + this.cdpTrackingData.region;
      variant.product_page_url = this.cdpTrackingData.store_url + location.pathname + '?variant=' + variant.id;

      data['items'] = [
        {
          ...this.getOptionProperties(this.cdpTrackingData.product_options, variant.options),
          type: 'product',
          id: window._cdpEventFunction.md5(variant.product_id),
          name: this.cdpTrackingData.product_name,
          sku: variant.sku,
          page_url: variant.product_page_url,
          image_url: variant.featured_image.src + '&width=1200',
          price: variant.price / 100,
          original_price: variant.compare_at_price / 100,
          variant: variant.title,
          parent_item_id: this.cdpTrackingData.product_parent_id,
          status: 'active',
          stock_status: 'true',
          region: this.cdpTrackingData.region, // SG/MY
          is_parent: 'false',
          cdp_source: this.cdpTrackingData.cdp_source,
        }
      ];
    } else {
      data['items'] = [
        {
          ...this.getOptionProperties(this.cdpTrackingData.product_options, this.cdpTrackingData.product_option_values),
          type: 'product',
          id: window._cdpEventFunction.md5(this.cdpTrackingData.product_id),
          name: this.cdpTrackingData.product_name,
          sku: this.cdpTrackingData.product_sku,
          page_url: this.cdpTrackingData.product_page_url,
          image_url: this.cdpTrackingData.product_featured_image,
          price: this.cdpTrackingData.product_sale_price,
          original_price: this.cdpTrackingData.product_original_price,
          variant: this.cdpTrackingData.product_variant_name,
          parent_item_id: this.cdpTrackingData.product_parent_id,
          status: 'active',
          stock_status: 'true',
          region: this.cdpTrackingData.region, // SG/MY
          is_parent: 'false',
          cdp_source: this.cdpTrackingData.cdp_source,
        }
      ];
    }

    data['extra'] = {
      identify_type: 'exact',
      identify_event: 'view_product',
      identify_time: this.getCurrentTime(),
    };

    if (Object.hasOwn(this.cdpTrackingData, 'customer_id')) {
      data['dims'] = {
        customers: {
          customer_id: window._cdpEventFunction.md5(this.cdpTrackingData.customer_id.toLowerCase()),
          name: this.cdpTrackingData.customer_name,
          email: this.cdpTrackingData.customer_email.toLowerCase(),
          phone: this.cdpTrackingData.customer_phone.replaceAll(' ', ''),
          available_in_my: this.cdpTrackingData.customer_in_my,
          cdp_source: this.cdpTrackingData.cdp_source,
        }
      };

      data['extra']['identify_id'] = window._cdpEventFunction.md5(this.cdpTrackingData.customer_id.toLowerCase());
    }

    console.log('track product view', JSON.parse(JSON.stringify(data)));
    window.web_event.track('product', 'view', data);
  }

  trackAddToCart(result, form, cartData) {
    const data = {};

    data['items'] = [];

    const item = result;

    data['items'].push({
      ...this.getOptionProperties(
        item.options_with_values.map((option) => option.name),
        item.options_with_values.map((option) => option.value),
      ),
      type: 'product',
      id: window._cdpEventFunction.md5(item.sku + '_' + this.cdpTrackingData.region),
      name: item.product_title,
      sku: item.sku,
      page_url:  this.cdpTrackingData.store_url + item.url,
      image_url: item.featured_image.url.replace(/^\/\//, 'https://') + '&width=1200',
      price: item.original_price / 100,
      variant: item.variant_title,
      parent_item_id: item.product_id.toString(),
      status: 'active',
      stock_status: 'true',
      region: this.cdpTrackingData.region, // SG/MY
      is_parent: 'false',
      quantity: item.quantity,
      cdp_source: this.cdpTrackingData.cdp_source,
    });

    data['extra'] = {
      cart_subtotal: cartData.original_total_price / 100,
      cart_item_count: cartData.items.length,
      identify_type: 'exact',
      identify_event: 'add_to_cart',
      identify_time: this.getCurrentTime(),
    };

    if (form.closest('quick-buy-drawer')) {
      data['extra']['event_source'] = 'sidebar';
    } else if (form.closest('.product__info')) {
      data['extra']['event_source'] = 'main_product';
    } else {
      data['extra']['event_source'] = 'other';
    }

    if (Object.hasOwn(this.cdpTrackingData, 'customer_id')) {
      data['dims'] = {
        customers: {
          customer_id: window._cdpEventFunction.md5(this.cdpTrackingData.customer_id.toLowerCase()),
          name: this.cdpTrackingData.customer_name,
          email: this.cdpTrackingData.customer_email.toLowerCase(),
          phone: this.cdpTrackingData.customer_phone.replaceAll(' ', ''),
          available_in_my: this.cdpTrackingData.customer_in_my,
          cdp_source: this.cdpTrackingData.cdp_source,
        }
      };

      data['extra']['identify_id'] = window._cdpEventFunction.md5(this.cdpTrackingData.customer_id.toLowerCase());
    }

    console.log('track product add_to_cart', JSON.parse(JSON.stringify(data)));
    window.web_event.track('product', 'add_to_cart', data);
  }

  trackRemoveFromCart(lineItemQuantity, newQuantity) {
    const lineItemData = JSON.parse(lineItemQuantity.querySelector('[data-line-item-json]').textContent);

    const data = {};

    data['items'] = [
      {
        ...this.getOptionProperties(lineItemData.product_options, lineItemData.product_option_values),
        type: 'product',
        id: window._cdpEventFunction.md5(lineItemData.product_id),
        name: lineItemData.product_name,
        sku: lineItemData.product_sku,
        page_url:  lineItemData.product_page_url,
        image_url: lineItemData.product_featured_image,
        price: lineItemData.product_original_price,
        variant: lineItemData.product_variant_name,
        parent_item_id: lineItemData.product_parent_id,
        status: 'active',
        stock_status: 'true',
        region: this.cdpTrackingData.region, // SG/MY
        is_parent: 'false',
        quantity: lineItemData.quantity - newQuantity,
        cdp_source: this.cdpTrackingData.cdp_source,
      },
    ];

    data['extra'] = {
      cart_item_count: (newQuantity === 0 ? lineItemData.cart_item_count - 1 : lineItemData.cart_item_count),
      identify_type: 'exact',
      identify_event: 'remove_cart',
      identify_time: this.getCurrentTime(),
    };

    if (Object.hasOwn(this.cdpTrackingData, 'customer_id')) {
      data['dims'] = {
        customers: {
          customer_id: window._cdpEventFunction.md5(this.cdpTrackingData.customer_id.toLowerCase()),
          name: this.cdpTrackingData.customer_name,
          email: this.cdpTrackingData.customer_email.toLowerCase(),
          phone: this.cdpTrackingData.customer_phone.replaceAll(' ', ''),
          available_in_my: this.cdpTrackingData.customer_in_my,
          cdp_source: this.cdpTrackingData.cdp_source,
        }
      };

      data['extra']['identify_id'] = window._cdpEventFunction.md5(this.cdpTrackingData.customer_id.toLowerCase());
    }

    console.log('track product remove_cart', JSON.parse(JSON.stringify(data)));
    window.web_event.track('product', 'remove_cart', data);
  }

  trackViewCart() {
    const data = {};
    data['items'] = [];

    let cartSubtotal = 0;

    const lineItemJsons = document.querySelectorAll('[data-line-item-json]');
    const keys = new Set();

    for (const json of lineItemJsons) {
      const lineItemData = JSON.parse(json.textContent);

      if (keys.has(lineItemData.key)) {
        continue;
      }

      keys.add(lineItemData.key);
      cartSubtotal = lineItemData.cart_original_total;

      data['items'].push({
        ...this.getOptionProperties(lineItemData.product_options, lineItemData.product_option_values),
        type: 'product',
        id: window._cdpEventFunction.md5(lineItemData.product_id),
        name: lineItemData.product_name,
        sku: lineItemData.product_sku,
        page_url:  lineItemData.product_page_url,
        image_url: lineItemData.product_featured_image,
        price: lineItemData.product_original_price,
        variant: lineItemData.product_variant_name,
        parent_item_id: lineItemData.product_parent_id,
        status: 'active',
        stock_status: 'true',
        region: this.cdpTrackingData.region, // SG/MY
        is_parent: 'false',
        quantity: lineItemData.quantity,
        cdp_source: this.cdpTrackingData.cdp_source,
      });
    }

    data['extra'] = {
      cart_subtotal: cartSubtotal,
      cart_item_count: data['items'].length,
      identify_type: 'exact',
      identify_event: 'view_cart',
      identify_time: this.getCurrentTime(),
    };

    if (Object.hasOwn(this.cdpTrackingData, 'customer_id')) {
      data['dims'] = {
        customers: {
          customer_id: window._cdpEventFunction.md5(this.cdpTrackingData.customer_id.toLowerCase()),
          name: this.cdpTrackingData.customer_name,
          email: this.cdpTrackingData.customer_email.toLowerCase(),
          phone: this.cdpTrackingData.customer_phone.replaceAll(' ', ''),
          available_in_my: this.cdpTrackingData.customer_in_my,
          cdp_source: this.cdpTrackingData.cdp_source,
        }
      };

      data['extra']['identify_id'] = window._cdpEventFunction.md5(this.cdpTrackingData.customer_id.toLowerCase());
    }

    console.log('track product view_cart', JSON.parse(JSON.stringify(data)));
    window.web_event.track('product', 'view_cart', data);
  }

  trackCheckout() {
    const data = {};
    data['items'] = [];

    let cartSubtotal = 0;

    const lineItemJsons = document.querySelectorAll('[data-line-item-json]');
    const keys = new Set();

    for (const json of lineItemJsons) {
      const lineItemData = JSON.parse(json.textContent);

      if (keys.has(lineItemData.key)) {
        continue;
      }

      keys.add(lineItemData.key);
      cartSubtotal = lineItemData.cart_original_total;

      data['items'].push({
        type: 'product',
        id: window._cdpEventFunction.md5(lineItemData.product_id),
        name: lineItemData.product_name,
        sale_price: lineItemData.product_sale_price,
        quantity: lineItemData.quantity,
        line_item_quantity: lineItemData.quantity,
        line_item_unit_price: lineItemData.product_original_price,
        line_item_discount_amount: lineItemData.product_discount_amount,
        line_item_rounded_amount: lineItemData.product_sale_price,
      });
    }

    data['extra'] = {
      cart_subtotal: cartSubtotal,
      cart_item_count: data['items'].length,
      identify_type: 'exact',
      identify_event: 'checkout',
      identify_time: this.getCurrentTime(),
    };

    if (Object.hasOwn(this.cdpTrackingData, 'customer_id')) {
      data['dims'] = {
        customers: {
          customer_id: window._cdpEventFunction.md5(this.cdpTrackingData.customer_id.toLowerCase()),
          name: this.cdpTrackingData.customer_name,
          email: this.cdpTrackingData.customer_email.toLowerCase(),
          phone: this.cdpTrackingData.customer_phone,
          first_name: this.cdpTrackingData.customer_first_name,
          last_name: this.cdpTrackingData.customer_last_name,
          company: this.cdpTrackingData.customer_company,
          address_1: this.cdpTrackingData.customer_address_1,
          address_2: this.cdpTrackingData.customer_address_2,
          city: this.cdpTrackingData.customer_city,
          province: this.cdpTrackingData.customer_province,
          country: this.cdpTrackingData.customer_country,
          zip: this.cdpTrackingData.customer_zip,
          available_in_my: this.cdpTrackingData.customer_in_my,
          cdp_source: this.cdpTrackingData.cdp_source,
        }
      };

      data['extra']['identify_id'] = window._cdpEventFunction.md5(this.cdpTrackingData.customer_id.toLowerCase());
    }

    console.log('track product checkout', JSON.parse(JSON.stringify(data)));
    window.web_event.track('product', 'checkout', data);
  }

  trackProductSearch() {
    const data = {};
    data['items'] = [];

    const container = document.querySelector('.product-list__inner');

    for (let i = 0; i < 10 && i < container.children.length; i++) {
      const item = container.children[i];
      const sku = item.dataset.variantSku;
      const title = JSON.parse('"' + item.dataset.productName + '"');

      data['items'].push({
        type: 'product',
        id: window._cdpEventFunction.md5(sku + '_' + this.cdpTrackingData.region),
        name: title,
        cdp_source: this.cdpTrackingData.cdp_source,
      });
    }

    const query = new URLSearchParams(location.search);

    data['extra'] = {
      src_search_term: query.get('q'),
      identify_type: 'exact',
      identify_event: 'product_search',
      identify_time: this.getCurrentTime(),
    };

    if (Object.hasOwn(this.cdpTrackingData, 'customer_id')) {
      data['dims'] = {
        customers: {
          customer_id: window._cdpEventFunction.md5(this.cdpTrackingData.customer_id.toLowerCase()),
          name: this.cdpTrackingData.customer_name,
          email: this.cdpTrackingData.customer_email.toLowerCase(),
          phone: this.cdpTrackingData.customer_phone.replaceAll(' ', ''),
          available_in_my: this.cdpTrackingData.customer_in_my,
          cdp_source: this.cdpTrackingData.cdp_source,
        }
      };

      data['extra']['identify_id'] = window._cdpEventFunction.md5(this.cdpTrackingData.customer_id.toLowerCase());
    }

    console.log('track browsing product_search', JSON.parse(JSON.stringify(data)));
    window.web_event.track('browsing', 'product_search', data);
  }

  trackIdentifyUser() {
    const data = {
      dims: {
        customers: {
          customer_id: window._cdpEventFunction.md5(this.cdpTrackingData.customer_id.toLowerCase()),
          available_in_my: this.cdpTrackingData.customer_in_my,
          is_loyalty_member: this.cdpTrackingData.customer_is_loyalty_member,
          is_loyalty_member_in_my: this.cdpTrackingData.customer_is_loyalty_member,
        }
      },
      extra: {
        identify_event: 'user_identify',
        identify_id: window._cdpEventFunction.md5(this.cdpTrackingData.customer_id.toLowerCase()),
        identify_time: this.getCurrentTime(),
      }
    };

    console.log('track user identify', JSON.parse(JSON.stringify(data)));
    window.web_event.track('user', 'identify', data);
  }

  trackUserSignIn() {
    if (Object.hasOwn(this.cdpTrackingData, 'customer_id')) {
      const data = {
        extra: {
          identify_type: 'exact',
          identify_event: 'sign_in',
          identify_time: this.getCurrentTime(),
          identify_id: window._cdpEventFunction.md5(this.cdpTrackingData.customer_id.toLowerCase()),
        },
        dims: {
          customers: {
            customer_id: window._cdpEventFunction.md5(this.cdpTrackingData.customer_id.toLowerCase()),
            name: this.cdpTrackingData.customer_name,
            email: this.cdpTrackingData.customer_email.toLowerCase(),
            phone: this.cdpTrackingData.customer_phone.replaceAll(' ', ''),
            gender: this.cdpTrackingData.customer_gender,
            accept_email_marketing: this.cdpTrackingData.customer_accept_email_marketing,
            accept_email_marketing_in_my: this.cdpTrackingData.customer_accept_email_marketing,
            accept_whatsapp_marketing: this.cdpTrackingData.customer_accept_whatsapp_marketing,
            accept_whatsapp_marketing_in_my: this.cdpTrackingData.customer_accept_whatsapp_marketing,
            is_loyalty_member: this.cdpTrackingData.customer_is_loyalty_member,
            is_loyalty_member_in_my: this.cdpTrackingData.customer_is_loyalty_member,
            available_in_my: this.cdpTrackingData.customer_in_my,
            cdp_source: this.cdpTrackingData.cdp_source,
          }
        }
      };

      console.log('track user sign in', JSON.parse(JSON.stringify(data)));
      window.web_event.track('user', 'sign_in', data);
    }
  }

  trackUserSignUp(submissionData) {
    const urlParams = new URLSearchParams(location.search);

    const data = {
      dims: {
        customers: {
          customer_id: window._cdpEventFunction.md5(submissionData.email.toLowerCase()),
          name: `${submissionData.first_name} ${submissionData.last_name}`,
          email: submissionData.email.toLowerCase(),
          accept_email_marketing: submissionData.accepts_marketing,
          accept_email_marketing_in_my: submissionData.accepts_marketing,
          phone: submissionData.phone.replaceAll(' ', ''),
          region: "MY", // SG/MY
          accept_whatsapp_marketing: submissionData.whatsapp,
          accept_whatsapp_marketing_in_my: submissionData.whatsapp,
          store_code: urlParams.get('store_code'),
          store_name: urlParams.get('store_name'),
          global_store_code: urlParams.get('global_store_code'),
          registration_source: urlParams.has('store_code') ? "QR Code" : "Shopify",// QR Code/Shopify
          gender: submissionData.gender,
          available_in_my: this.cdpTrackingData.customer_in_my,
          is_loyalty_member: submissionData.is_loyalty_member,
          is_loyalty_member_in_my: submissionData.is_loyalty_member,
          cdp_source: this.cdpTrackingData.cdp_source,
        }
      },
      extra: {
        region: "MY",
        registration_source: urlParams.has('store_code') ? "QR Code" : "Shopify",// QR Code/Shopify
        store_code: urlParams.get('store_code'),
        store_name: urlParams.get('store_name'),
        global_store_code: urlParams.get('global_store_code'),
        identify_type: "exact",
        identify_event: "sign_up",
        identify_id: window._cdpEventFunction.md5(submissionData.email.toLowerCase()),
        identify_time: this.getCurrentTime(),
      }
    };

    console.log('track user sign up', JSON.parse(JSON.stringify(data)));
    window.web_event.track('user', 'sign_up', data);
  }

  trackCustomerUpdate(submissionData, yotpoMemberStatus) {
    const data = {
      dims: {
        customers: {
          customer_id: window._cdpEventFunction.md5(submissionData.email.toLowerCase()),
          name: `${submissionData.first_name} ${submissionData.last_name}`,
          email: submissionData.email.toLowerCase(),
          phone: submissionData.phone.replaceAll(' ', ''),
          accept_email_marketing: submissionData.accepts_marketing,
          accept_email_marketing_in_my: submissionData.accepts_marketing,
          accept_whatsapp_marketing: submissionData.whatsapp,
          accept_whatsapp_marketing_in_my: submissionData.whatsapp,
          is_loyalty_member: yotpoMemberStatus,
          available_in_my: this.cdpTrackingData.customer_in_my,
          cdp_source: this.cdpTrackingData.cdp_source,
        }
      },
      extra: {
        identify_event: "update_customer",
        identify_id: window._cdpEventFunction.md5(submissionData.email.toLowerCase()),
        identify_time: this.getCurrentTime(),
      }
    };

    console.log('track user update', JSON.parse(JSON.stringify(data)));
    window.web_event.track('customer', 'update', data);
  }

  trackViewBlogs() {
    const data = {};
    data['items'] = [];

    data['items'].push({
      type: 'article',
      id: window._cdpEventFunction.md5(this.cdpTrackingData.article_page_url),
      name: this.cdpTrackingData.article_title,
      title: this.cdpTrackingData.article_title,
      page_url: this.cdpTrackingData.article_page_url,
      tags: this.cdpTrackingData.article_tags,
      tags_string: this.cdpTrackingData.article_tags.join(','),
      cdp_source: this.cdpTrackingData.cdp_source,
    });

    data['extra'] = {
      page_title: this.cdpTrackingData.article_title,
      identify_type: 'exact',
      identify_event: 'view_blog',
      identify_time: this.getCurrentTime(),
    };

    if (Object.hasOwn(this.cdpTrackingData, 'customer_id')) {
      data['dims'] = {
        customers: {
          customer_id: window._cdpEventFunction.md5(this.cdpTrackingData.customer_id.toLowerCase()),
          name: this.cdpTrackingData.customer_name,
          email: this.cdpTrackingData.customer_email.toLowerCase(),
          phone: this.cdpTrackingData.customer_phone.replaceAll(' ', ''),
          available_in_my: this.cdpTrackingData.customer_in_my,
          cdp_source: this.cdpTrackingData.cdp_source,
        }
      };

      data['extra']['identify_id'] = window._cdpEventFunction.md5(this.cdpTrackingData.customer_id.toLowerCase());
    }

    console.log('track blog view', JSON.parse(JSON.stringify(data)));
    window.web_event.track('blog', 'view', data);
  }

  // Builds cdp.asia item properties from parallel arrays of option names and values. Spread the
  // result before an item's fixed properties so an option named e.g. "Type" can't overwrite them.
  getOptionProperties(names, values) {
    const properties = {
      color: '',
      size: '',
      uk_size: '',
      width: '',
      style: '',
      fitting: '',
    };

    (names || []).forEach((name, i) => {
      const value = (values || [])[i] ?? '';
      const key = name.trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');

      // Products without variants carry a placeholder "Title: Default Title" option.
      if (!key || (key == 'title' && value == 'Default Title')) {
        return;
      }

      for (const property of CdpTrackingCode.OPTION_PROPERTY_MAP[key] || [key]) {
        properties[property] = value;
      }
    });

    return properties;
  }

  getCurrentTime() {
    const now = new Date();
    const year = now.getFullYear().toString();
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const day = now.getDate().toString().padStart(2, '0');
    const hour = now.getHours().toString().padStart(2, '0');
    const minute = now.getMinutes().toString().padStart(2, '0');
    const second = now.getSeconds().toString().padStart(2, '0');

    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
  }
}

(function () {
  'use strict';

  let repeatCount = 100;
  repeat();

  function repeat() {
    if (window._cdpEventFunction) {
      window.cdpTrackingCode = new CdpTrackingCode();
      return;
    }

    if (repeatCount > 0) {
      repeatCount -= 1;
      setTimeout(repeat, 100);
    }
  }
})();
